import Joi from "joi";

import { setDoc } from "@/javascript/db";

const DESCRIPTION_SCHEMA = Joi.object({
  microbiomeId: Joi.string()
    .regex(/^.:.+$/)
    .required(),
  classification: Joi.string()
    .length(1)
    .required(),
  displayName: Joi.string().required(),
  description: Joi.string().required(),
  expandedDescription: Joi.string(),
  img: Joi.string(),
  source: Joi.array().items(Joi.string().uri()),
  dictionary: Joi.object().pattern(Joi.string(), Joi.string())
}).required();

const PAPER_SCHEMA = Joi.object({
  title: Joi.string().required(),
  displayTitle: Joi.string().required(),
  description: Joi.string().required(),
  expandedDescription: Joi.string().required(),
  summary: Joi.string().required(),
  didYouKnow: Joi.string().required(),
  didYouKnowSource: Joi.string().required(),
  img: Joi.string().allow(""),
  sources: Joi.array()
    .min(1)
    .items(
      Joi.object({
        displayName: Joi.string().allow(""),
        link: Joi.string().uri()
      })
    )
    .required(),
  dictionary: Joi.object().pattern(Joi.string(), Joi.string()),
  authors: Joi.array()
    .min(1)
    .items(Joi.string())
    .required(),
  publicationDate: Joi.string().required(),
  journal: Joi.string().required(),
  links: Joi.array().items(
    Joi.object({
      displayName: Joi.string().allow(""),
      link: Joi.string().uri()
    })
  ),
  tags: Joi.object().pattern(Joi.string(), Joi.bool().valid(true)),
  relevantBacteria: Joi.array()
    .items(
      Joi.object({
        microbiomeId: Joi.string()
          .regex(/^.:.+$/)
          .required()
      }).unknown()
    )
    .required(),
  columnDisplayName: Joi.string().required()
}).required();

/**
 * Admin function for setting the microbiome description.
 * The collection is keyed by the display name so it will overwrite.
 */
const postMicrobiomeDescription = async description => {
  const { error, value: microbiomeDescription } = DESCRIPTION_SCHEMA.validate(
    description
  );

  if (error) return error;

  const { microbiomeId, classification, displayName } = microbiomeDescription;

  if (microbiomeId !== `${classification}:${displayName}`) {
    return "microbiomeId must be of the form [classification]:[displayName]";
  }

  await setDoc("microbiome-descriptions", microbiomeId, microbiomeDescription);
};

/**
 * Admin function for setting the microbiome newsfeed.
 * The collection is keyed by the display name so it will overwrite.
 */
const postMicrobiomePaper = async paper => {
  const { error, value: microbiomeNewsfeed } = PAPER_SCHEMA.validate(paper);
  if (error) return error;

  let { title } = microbiomeNewsfeed;
  // Document IDs can't contain `/`
  title = title.replace(/\//g, "");
  await setDoc("microbiome-newsfeed", title, microbiomeNewsfeed);
};

export { postMicrobiomeDescription, postMicrobiomePaper };
